import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 130 52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "130",
      height: "51",
      y: ".469",
      fill: "#fff",
      rx: "14"
    }, null, -1),
    _createElementVNode("rect", {
      width: "47",
      height: "39",
      x: "6",
      y: "6.469",
      fill: "#000",
      rx: "10"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m28 26.988.258-.527h.61l-.587 2.25c-.093.36-.363.547-.808.562h-1.489v2.391c0 .29.125.5.375.633.258.125.723.21 1.395.258v.914a136.885 136.885 0 0 0-7.172 0v-.914c.781-.047 1.313-.13 1.594-.246.281-.133.422-.348.422-.645v-2.39h-5.25l-.434-1.618 7.652-9.48h1.418v9.433h.48c.477 0 .817-.035 1.02-.105.211-.07.383-.242.516-.516Zm-9.96.621h4.558v-5.613l-4.559 5.613Zm23.917 4.97.504.07v.82a75.56 75.56 0 0 0-5.953 0v-.844l.504-.047c.46-.047.5-.39.117-1.031l-1.488-2.379-1.559 2.309c-.188.32-.246.582-.176.785.078.195.258.3.54.316l.785.047v.844a51.558 51.558 0 0 0-5.157 0v-.82l.457-.07c1.016-.15 1.825-.661 2.426-1.536l2.016-2.953-2.836-4.535c-.461-.758-.965-1.164-1.512-1.22l-.504-.07v-.82h6.024v.844l-.364.023c-.289.016-.453.133-.492.352-.039.211.047.477.258.797l1.242 1.969 1.371-1.992c.196-.32.235-.582.117-.786-.117-.21-.347-.324-.691-.34l-.574-.023v-.844h5.133v.82l-.434.07c-.563.095-1.023.25-1.383.47-.351.203-.7.558-1.043 1.066l-1.816 2.637 3.07 4.851c.258.43.484.735.68.914.195.157.441.258.738.305Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M107.833 30.785c-1.696 0-3.072-1.431-3.072-3.2 0-1.768 1.376-3.2 3.072-3.2 1.696 0 3.07 1.434 3.07 3.198 0 1.765-1.376 3.2-3.07 3.2v.002Zm3.07-9.025v1.624a4.771 4.771 0 0 0-3.831-1.919c-3.05 0-5.414 2.741-5.414 6.118 0 3.378 2.362 6.12 5.414 6.12a4.818 4.818 0 0 0 4.017-2.172v1.88H114v-11.65l-3.097-.001Zm-35.554-3.23h3.105v14.881h-3.105v-14.88Zm6.673 8.274c0-3.202 1.958-5.338 4.673-5.338 1.684 0 3.014.752 3.817 2.031.803-1.28 2.135-2.031 3.819-2.031 2.717 0 4.673 2.142 4.673 5.338v6.607h-3.105v-6.942c0-1.248-.825-2.064-1.917-2.064-1.093 0-1.918.816-1.918 2.064v6.942H88.96v-6.942c0-1.248-.825-2.064-1.918-2.064-1.092 0-1.917.816-1.917 2.064v6.942H82.02l.002-6.607Zm-12.295-4.922c-.735-2.763-2.288-3.648-3.768-3.648s-3.033.885-3.767 3.648L59 33.411h3.146c.21-.856.699-1.617 1.39-2.162a3.919 3.919 0 0 1 4.847 0 3.944 3.944 0 0 1 1.39 2.162h3.146l-3.192-11.529Zm-3.768 5.844a3.776 3.776 0 0 0-2.577.999l1.8-6.708c.173-.641.427-.845.777-.845.349 0 .605.194.776.845l1.803 6.71a3.78 3.78 0 0 0-2.58-1.001Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "alma"}) } }